export const BENEFICIARIES_REGISTER_STEP_TITLE = 'Registra tus beneficiarios';
export const BENEFICIARIES_REGISTER_INFO = 'Para realizar el cálculo, es necesario que declares a tus beneficiarios. Estos pueden ser:';

export const BENEFICIARIES_REGISTER_LIST = [
  'Cónyuge o concubino.',
  'Hijos menores de 18 años o mayores con condición de inválidos.',
  'Padres que dependen económicamente de ti (madre mayor de 55 años, padre mayor de 60 años).',
  'Padre y/o madre inválidos total o parcialmente a juicio del comité médico competente.',
]

export const BENEFICIARIES_MAX_NUMBER = 10;

export const BENEFICIARIES_FORM = [
  {
    label: 'Parentesco',
    name: 'relationship'
  },
  {
    label: 'Estado de salud',
    name: 'healthCondition'
  },

  {
    label: 'Fecha de nacimiento',
    name: 'dateOfBirth'
  },

  {
    label: 'Género',
    name: 'gender'
  }
]

export const BENEFICIARIES_EMPTY_REGISTER  = BENEFICIARIES_FORM.reduce((acc, curr) => ({ ...acc, [curr.name]: '' }), {});

export const BENEFICIARIES_ID_PARAMS = {
  RELATIONSHIP: {
    SPOUSE: 15,
    CONCUBINE: 16,
    CHILD: 17,
    PARENT: 18,
  },
  HEALTH_CONDITION: {
    HEALTHY: 21,
    INVALID: 22,
  },
  GENDER: {
    FEMALE: 19,
    MALE: 20,
  },
};

export const BENEFICIARIES_REGISTER_NOTIFICATIONS = {
  MESSAGE: {
    SPOUSE_ERROR: 'Ya registraste un cónyuge, por favor verifica.',
    CONCUBINE_ERROR: 'Ya registraste un(a) concubino(a), por favor verifica.',
    SPOUSE_CONCUBINE_ERROR: 'Solo puedes registrar un cónyuge o un concubino, por favor verifica.',
    CHILDREN_ERROR: 'La edad de tu hijo(a) debe ser menor de 18 años, por favor verifica.',
    FATHER_ERROR: 'Ya registraste a tu padre, por favor verifica.',
    MOTHER_ERROR: 'Ya registraste a tu madre, por favor verifica.',
    FATHER_BIRTHDAY_ERROR: 'La edad de tu padre no puede ser menor o igual a 60 años, por favor verifica',
    MOTHER_BIRTHDAY_ERROR: 'La edad de tu madre no puede ser menor o igual a 55 años, por favor verifica',
  },
  TYPE: {
    ERROR: 'error',
    INFO: 'info',
  },
}